import styled from "@emotion/styled";
import Box from "@mui/material/Box";
import {
  JustifyContentTypes,
  FlexDirectionTypes,
  flex,
} from "shared/theme/mixins";

const FlexColumn = styled(Box)<{
  ai?: string;
  jc?: JustifyContentTypes;
  fd?: FlexDirectionTypes;
}>`
  ${(props) => flex({ ai: props.ai, jc: props.jc, fd: props.fd ?? "column" })};
`;

export default FlexColumn;
